module.exports = __webpack_public_path__ + "static/img/5.285dde98.jpg";